import { Home } from "./pages";


const App = () => {
  process.env.CI = false;

  return (
    <>
      <Home />
    </>
  );
};

export default App;
